export default __webpack_public_path__ + "static/media/icon3.1a188506.svg";